import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type UpdateJobNoteRequestBody = ApiRequestBody<typeof endpoints.jobNote, 'put'>;
type UpdateJobNoteParams = {
  jobId: string;
  noteId: string;
  body: UpdateJobNoteRequestBody;
};

export const useUpdateJobNoteMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, noteId, body }: UpdateJobNoteParams) => {
      const { data } = await fetchClient.PUT(endpoints.jobNote, {
        params: { path: { jobId, id: noteId } },
        body,
      });

      return data;
    },
    onSettled: (_data, _error, { jobId, noteId }) => {
      invalidateQuery(jobsQueryKeys.notes(jobId))();
      invalidateQuery(jobsQueryKeys.note(jobId, noteId))();
    },
  });
};
